import * as yup from 'yup';
import { fieldValidator } from 'src/utils/formUtils';

import { i18n } from '@lt/localization';

export const getEmailError = (value?: string): string | undefined =>
  fieldValidator(
    yup
      .string()
      .matches(/^\s*\S+@\S+\.\S+\s*$/, i18n.t('checkout.loginForm.emailError')),
  )(value);
